import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { CheckoutState } from '../../hooks/useCheckout';
import { btnPrimary } from '../ui/buttonStyles';
import { FormField } from './FormField';
export function ContactStep({
  checkout
}: {
  checkout: CheckoutState;
}) {
  const {
    form,
    errors,
    update,
    submitStep
  } = checkout;
  return <form noValidate onSubmit={e => {
    e.preventDefault();
    submitStep('contact');
  }} data-id="element-90" data-mp="3n8wjk5vid17g">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-91" data-mp="2ul0qdb55drff">
        <FormField id="email" label="Adresse e-mail" type="email" autoComplete="email" className="sm:col-span-2" value={form.email} onChange={e => update('email', e.target.value)} error={errors.email} placeholder="vous@exemple.fr" data-id="element-92" data-mp="2uls9vnlgzypc" />
        <FormField id="firstName" label="Prénom" autoComplete="given-name" value={form.firstName} onChange={e => update('firstName', e.target.value)} error={errors.firstName} data-id="element-93" data-mp="evz0zfd0yeeu" />
        <FormField id="lastName" label="Nom" autoComplete="family-name" value={form.lastName} onChange={e => update('lastName', e.target.value)} error={errors.lastName} data-id="element-94" data-mp="1ak626vxz0p59" />
        <FormField id="phone" label="Téléphone" type="tel" optional autoComplete="tel" className="sm:col-span-2" value={form.phone} onChange={e => update('phone', e.target.value)} error={errors.phone} placeholder="Pour vous prévenir quand la commande est prête" data-id="element-95" data-mp="11jgaa3btziwt" />
      </div>
      <button type="submit" className={`${btnPrimary} mt-6 w-full sm:w-auto`} data-id="element-96" data-mp="iut3nge0alh4">
        Continuer vers la livraison <ArrowRightIcon className="h-4 w-4" data-id="element-97" data-mp="dtdizpfqqgz9" />
      </button>
    </form>;
}